/* eslint-disable no-unused-vars */
import { Fragment, useContext, useEffect, useRef, useState } from 'react';
import {
  errorToast,
  useOutsideClick,
  getFilterKey,
  convertToIndianDate,
  jsonToCsv,
  convertCodeToType,
  convertCodeToStatus,
  convertCodeToPlatform,
  getLocalStorageItem
} from '../../../utils/helper';
import { Helmet } from 'react-helmet';
import {
  ACCOUNT_TYPE,
  JOB_ROLES,
  PER_PAGE,
  SIGN_UP_PLATFORM,
  STATUS_FOR_DROPDOWN
} from '../../../utils/constants';
import { FunnelIcon } from '@heroicons/react/24/outline';
import {
  Combobox,
  ComboboxButton,
  ComboboxInput,
  ComboboxOption,
  ComboboxOptions,
  Transition
} from '@headlessui/react';

import { CheckIcon, ChevronDownIcon, XMarkIcon } from '@heroicons/react/20/solid';
import Topbar from '../../PulseSurvey/Topbar';
import { Api } from '../../../api';
import Loader from '../../../component/common/Loader';
import Breadcrumb from '../../../component/common/Breadcrumb';
import SelectMenu from '../../../component/common/SelectMenu';
import SearchInput from '../../../component/common/Input/SearchInput';
import Table from '../../../component/common/Table';
import Pagination from '../../../component/common/Pagination/Pagination';
import { SidebarContext } from '../../../context/SidebarContext';
import { FilterPanel, TableCard} from '../../../component/common/designSystem';

const pages = [{ name: 'Kids', href: '/kids', current: true }];

const columns = [
  {
    title: 'Profile',
    key: 'profile',
    sortable: false,
    type: 'profile',
    align: 'left'
  },
  {
    title: 'Parent',
    key: 'parent_name',
    sortable: false,
    type: 'text',
    align: 'left'
  },
  {
    title: 'DOB',
    key: 'dob',
    sortable: false,
    sortKey: 'dob',
    type: 'date',
    align: 'left'
  },

  {
    title: 'Last Login',
    key: 'last_login',
    sortable: false,
    type: 'date',
    align: 'left'
  },
  {
    title: 'Registered On',
    key: 'createdAt',
    extend: true,
    sortable: false,
    type: 'date',
    align: 'left'
  },
  // {
  //   title: 'Status',
  //   key: 'status',
  //   sortable: false,
  //   sortKey: 'status',
  //   type: 'toggle',
  //   align: 'left'
  // },
  {
    title: '',
    key: 'action',
    type: 'action',
    align: 'right',
    isView: '/kids/view/:id',
    isDelete: false
  }
];

export default function Kids() {
  const wrapperRef = useRef(null);
  const [loader, setLoader] = useState(true);
  const [kidsList, setKidsList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortOrder, setSortOrder] = useState(-1);
  const [sortBy, setSortBy] = useState('');
  const [selectedPerPage, setSelectedPerPage] = useState(PER_PAGE[0]);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [filterQuery, setFilterQuery] = useState('');
  const [showCalendar, setShowCalendar] = useState(false);

  const [query, setQuery] = useState('');
  const [selected, setSelected] = useState('');
  const [selectedFilterJob, setSelectedFilterJob] = useState('');
  const [jobs, setJobs] = useState(JOB_ROLES);
  const [parentsList, setParentsList] = useState([]);
  const [filterCriteria, setFilterCriteria] = useState({
    accountType: '',
    accountStatus: '',
    jobRole: '',
    loginPlatform: ''
  });

  const calendarRef = useRef();

  useOutsideClick(calendarRef, () => {
    if (showCalendar) setShowCalendar(!showCalendar);
  });
  const { isB2BFansMode: isFanMode } = useContext(SidebarContext);
  const userData = getLocalStorageItem('userData') && JSON.parse(getLocalStorageItem('userData'));

  // useEffect(() => {
  //   if (userData.userType === 3 || userData.userType === 4) {
  //     window.location.href = userData?.slug ? `/${userData?.slug}/kids` : '/kids';
  //   }
  // }, [userData]);

  // const handlePagination = (pageNumber, pageSize, searchKey, query, sortBy, sortOrder) => {
  //     setLoader(true);
  // Api.getUsers(pageNumber, pageSize, searchKey, query, sortBy, sortOrder).then((response) => {
  //         if (response?.data?.meta?.code === 1) {
  //             setUsersList(response?.data?.data);
  //             setCurrentPage(pageNumber);
  //             setTotalCount(response?.data?.meta?.totalRecords);
  //             setLoader(false);
  //         } else if (response?.code === 401) {
  //             setLoader(false);
  //             errorToast(response?.message);
  //         } else if (response?.data?.meta?.code === 0) {
  //             setCurrentPage(1);
  //             setUsersList([]);
  //             setTotalCount(0);
  //             setLoader(false);
  //             errorToast(response?.data?.meta?.message);
  //         } else {
  //             setLoader(false);
  //         }
  //     });
  // };

  const handlePagination = (pageNumber, pageSize, searchKey, query) => {
    setLoader(true);
    if (query) {
      query = query + `&isMember=${isFanMode}`;
    } else {
      query = `&isMember=${isFanMode}`;
    }
    Api.getKidsList(searchKey, pageNumber, pageSize, query).then((response) => {
      if (response?.status === 200) {
        setKidsList(response?.data?.data);
        setCurrentPage(pageNumber);
        setTotalCount(response?.data?.meta?.total_data);
        setLoader(false);
      } else if (response?.code === 401) {
        setLoader(false);
        errorToast(response?.message);
      } else if (response?.data?.meta?.code === 0) {
        setCurrentPage(1);
        setKidsList([]);
        setTotalCount(0);
        setLoader(false);
        errorToast(response?.data?.meta?.message);
      } else {
        setLoader(false);
      }
    });
  };

  const handleSortBy = (sortByValue) => {
    setSortBy(sortByValue);
    if (sortByValue === sortBy) {
      let tempSortOrder = sortOrder === 1 ? -1 : 1;
      setSortOrder(tempSortOrder);
      handlePagination(
        currentPage,
        selectedPerPage?.value,
        searchTerm,
        filterQuery,
        sortByValue,
        tempSortOrder
      );
    } else {
      setSortOrder(1);
      handlePagination(
        currentPage,
        selectedPerPage?.value,
        searchTerm,
        filterQuery,
        sortByValue,
        1
      );
    }
  };
  const getParents = (query) => {
    Api.getParentList(query).then((response) => {
      if (response?.status === 200) {
        setParentsList(response?.data?.data);
      } else {
        errorToast(response?.message);
      }
    });
  };

  useEffect(() => {
    getParents();
  }, []);

  useEffect(() => {
    if (searchTerm) {
      let searchParam = searchTerm.trim();
      const delayDebounceFn = setTimeout(() => {
        handlePagination(1, selectedPerPage?.value, searchParam, filterQuery, sortBy, sortOrder);
      }, 800);

      return () => clearTimeout(delayDebounceFn);
    } else {
      handlePagination(1, 10, '', '', sortBy, sortOrder);
    }
  }, [searchTerm]);

  const handlePerPage = (perPage) => {
    setSelectedPerPage(perPage);
    handlePagination(1, perPage.value, searchTerm, filterQuery, sortBy, sortOrder);
  };

  useOutsideClick(wrapperRef, () => {
    if (showFilterModal) setShowFilterModal(!showFilterModal);
  });

  const filterHandler = (data, key) => {
    console.log(data, key);
    setFilterCriteria((prevData) => ({
      ...prevData,
      [key]: data
    }));
    let clone = JSON.parse(JSON.stringify(filterCriteria));
    const newData = { ...clone, [key]: data };
    let tempFilterQuery = [];
    Object.keys(newData).forEach(function (key) {
      if (key === 'parentId') {
        if (newData[key]?._id) {
          tempFilterQuery.push(`&${key}=${newData[key]?._id}`);
          setSelectedFilterJob(newData[key]?.name);
        }
      } else if (newData[key]?.value?.toString()) {
        tempFilterQuery.push(`&${key}=${newData[key]?.value}`);
      }
    });
    let query = tempFilterQuery?.toString()?.replaceAll(',', '');
    console.log(query, 'query');
    setFilterQuery(query);
    handlePagination(1, selectedPerPage.value, searchTerm, query, sortBy, sortOrder);
  };

  const resetHandler = () => {
    setFilterCriteria({
      accountType: '',
      accountStatus: '',
      jobRole: '',
      loginPlatform: ''
    });
    setFilterQuery('');
    setSelectedFilterJob('');
    setSelected('');
    setShowFilterModal(false);
    handlePagination(1, selectedPerPage.value, searchTerm, '', sortBy, sortOrder);
  };

  const refreshTable = () =>
    handlePagination(1, selectedPerPage?.value, '', filterQuery, sortBy, sortOrder);

  const downloadCsvFile = (data, filename) => {
    if (!data || data.length === 0) {
      console.error('JSON array is empty.');
      return;
    }

    data.map((i) => {
      i.createdAt = convertToIndianDate(i.createdAt);
      i.registeredOn = convertToIndianDate(i.registeredOn);
      i.accountType = convertCodeToType(i.accountType);
      i.accountStatus = convertCodeToStatus(i.accountStatus);
      i.loginPlatform = convertCodeToPlatform(i.loginPlatform);
    });

    const csvContent = jsonToCsv(data);

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', filename || 'data.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    getParents(query);
  }, [query]);
  return (
    <div className="relative lg:mb-[45px]">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Kids | Shoorah Admin</title>
      </Helmet>
      <Topbar title={'Kids'} />
      {loader ? <Loader /> : null}
      <Breadcrumb pageList={pages} className="lg:mt-8" />
      <div className="mt-6">
        <div className="flex flex-wrap justify-between gap-2">
          <div className="flex">
            <div className="hidden lg:flex mr-3 self-center">
              <span className="self-center text-sm mr-2 text-shoorah-lightBlack dark:text-white">
                Per Page
              </span>
              <div className="w-[80px]">
                <SelectMenu
                  menuList={PER_PAGE}
                  showLabel={false}
                  defaultSelected={selectedPerPage}
                  setSelectedMenu={handlePerPage}
                />
              </div>
            </div>
            <div className="self-center">
              <SearchInput
                id="searchKey"
                name="searchKey"
                type="text"
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search by kid name"
              />
            </div>
          </div>
          <div className="flex flex-wrap sm:gap-0 gap-3 justify-between">
            <div className=" flex lg:hidden self-center">
              <div className="w-[80px]">
                <SelectMenu
                  menuList={PER_PAGE}
                  showLabel={false}
                  defaultSelected={selectedPerPage}
                  setSelectedMenu={handlePerPage}
                />
              </div>
            </div>
            <div className="flex flex-wrap">
              <div className="sm:ml-3 self-center inline-flex flex-wrap items-center justify-center">
                {/* <button
                  className="btn-primary mx-3 sm:w-auto"
                  onClick={() => downloadCsvFile(kidsList, 'kids.csv')}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    className="bi bi-save text-white w-[18px] h-[20px] inline rotate-180"
                    viewBox="0 0 16 16"
                  >
                    <path d="M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9.5a1 1 0 0 0-1 1v7.293l2.646-2.647a.5.5 0 0 1 .708.708l-3.5 3.5a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L7.5 9.293V2a2 2 0 0 1 2-2H14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h2.5a.5.5 0 0 1 0 1H2z" />
                    <title>Export Kids</title>
                  </svg>
                </button> */}

                <button
                  className="btn-primary sm:w-auto"
                  onClick={() => setShowFilterModal((state) => !state)}
                >
                  <FunnelIcon className="text-white w-[18px] h-[20px] inline" />
                </button>
              </div>
            </div>
          </div>
        </div>

        <FilterPanel
          open={showFilterModal}
          onClose={() => setShowFilterModal(false)}
          onReset={resetHandler}
        >
              {/* <div>
                <SelectMenu
                  menuList={ACCOUNT_TYPE}
                  defaultSelected={filterCriteria.accountType}
                  label="Subscription Status"
                  isRequired={false}
                  setSelectedMenu={(data) => filterHandler(data, 'accountType')}
                />
              </div> */}
              {/* <div>
                <SelectMenu
                  menuList={STATUS_FOR_DROPDOWN}
                  label="Account status"
                  isRequired={false}
                  defaultSelected={filterCriteria.accountStatus}
                  setSelectedMenu={(data) => filterHandler(data, 'accountStatus')}
                />
              </div>
              <div>
                <SelectMenu
                  menuList={SIGN_UP_PLATFORM}
                  label="Signup Platform"
                  isRequired={false}
                  defaultSelected={filterCriteria.loginPlatform}
                  setSelectedMenu={(data) => filterHandler(data, 'loginPlatform')}
                />
              </div>
              <div>
                <SelectMenu
                  menuList={[
                    { name: 'All', value: null },
                    { name: 'Super Admin', value: 'admin' },
                    { name: 'Ripple', value: 'ripple' }
                  ]}
                  label="Added by"
                  isRequired={false}
                  defaultSelected={filterCriteria.addedBy}
                  setSelectedMenu={(data) => filterHandler(data, 'addedBy')}
                />
              </div>
              <div>
                <SelectMenu
                  menuList={[
                    { name: 'All', value: null },
                    { name: 'B2C', value: false },
                    { name: 'B2B', value: true }
                  ]}
                  label="Role"
                  isRequired={false}
                  defaultSelected={filterCriteria.role}
                  setSelectedMenu={(data) => filterHandler(data, 'role')}
                />
              </div> */}

              <div className="flex relative w-full flex-col">
                <label
                  htmlFor="jobRole"
                  className="text-sm dark:text-white block font-medium text-gray-700"
                >
                  Parent
                </label>
                <Combobox
                  value={parentsList}
                  onChange={(data) => {
                    filterHandler(data, 'parentId');
                  }}
                >
                  <div className="relative w-full pr-4 overflow-hidden outline-none appearance-none bg-transparent text-[#666666] dark:text-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder rounded-input border px-1">
                    <ComboboxInput
                      className={
                        'w-full capitalize outline-none appearance-none rounded-lg border-none bg-white/5 py-1.5 pr-8 pl-3 text-sm/6 '
                      }
                      placeholder="Select Parent"
                      displayValue={selected}
                      onChange={(event) => setQuery(event.target.value)}
                    />
                    <ComboboxButton className="group absolute inset-y-0 right-0 px-2.5">
                      <ChevronDownIcon className="size-4 " />
                    </ComboboxButton>
                  </div>
                  <Transition
                    as={Fragment}
                    leave="transition ease-in duration-100"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                    afterLeave={() => setQuery('')}
                  >
                    <ComboboxOptions
                      anchor="bottom"
                      className="w-[15rem] z-50 bg-white shadow rounded-xl border border-white/5 p-1 empty:hidden"
                    >
                      {parentsList.map((parent) => (
                        <ComboboxOption
                          key={parent?._id}
                          value={parent}
                          className="group flex cursor-default items-center gap-2 rounded-lg py-1.5 px-3 select-none"
                        >
                          <CheckIcon className="invisible size-4 fill-white " />
                          <div className="text-sm/6">{parent?.name}</div>
                        </ComboboxOption>
                      ))}
                    </ComboboxOptions>
                  </Transition>
                </Combobox>
              </div>
            </FilterPanel>
        
        <TableCard
          pagination={{
            currentPage: currentPage,
            totalCount: totalCount,
            pageSize: selectedPerPage?.value,
            onPageChange: (page) =>
              handlePagination(
                page,
                selectedPerPage?.value,
                searchTerm,
                filterQuery,
                sortBy,
                sortOrder
              ),
            onPageSizeChange: (size) =>
              handlePerPage(PER_PAGE.find((o) => o.value === size) || PER_PAGE[0]),
            pageSizeOptions: PER_PAGE.map((o) => o.value)
          }}
        >
          <Table
            columns={columns}
            data={kidsList}
            name={'kids_table'}
            bottomBorder={totalCount > selectedPerPage?.value}
            setSortBy={(sort) => handleSortBy(sort)}
            refreshTable={refreshTable}
            loader={loader}
          />
        </TableCard>
      </div>
      
    </div>
  );
}
